import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'material-ui/Tabs';
import TextField from 'material-ui/TextField';
import { FormProvider, FormSection } from 'components';
import { setValue } from 'redux/modules/customAudiences';
import { changeField } from 'redux/modules/forms';
import * as styles from './CustomAudienceBuilder.scss';
var CABFileSection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var fileForm = state.forms && state.forms["fileForm_".concat(orgId)] ? _objectSpread({}, state.forms["fileForm_".concat(orgId)]) : null;
  var validationErrors = fileForm && fileForm.validationErrors ? fileForm.validationErrors : null;
  return {
    facebookPixels: state.customAudiences.facebookPixels && state.customAudiences.facebookPixels[orgId] ? state.customAudiences.facebookPixels[orgId] : [],
    fileForm: fileForm,
    formName: "fileForm_".concat(orgId),
    theme: state.theme,
    organization: state.organization.current,
    customAudienceBuilder: state.customAudiences.builder,
    audienceName: state.customAudiences.audienceName
  };
}, {
  changeField: changeField,
  setValue: setValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(CABFileSection, _Component);

  var _super = _createSuper(CABFileSection);

  function CABFileSection() {
    _classCallCheck(this, CABFileSection);

    return _super.apply(this, arguments);
  }

  _createClass(CABFileSection, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          formName = _this$props.formName,
          fileForm = _this$props.fileForm,
          organization = _this$props.organization,
          theme = _this$props.theme;
      return /*#__PURE__*/React.createElement(FormProvider, {
        name: "fileForm_".concat(organization.id),
        defaultState: {
          audienceFile: null,
          emailTextInput: '',
          entryType: true
        }
      }, !!fileForm && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        key: "customaudience"
      }, /*#__PURE__*/React.createElement(TextField, {
        floatingLabelText: "Audience Name",
        name: 'audienceNameField',
        value: this.props.audienceName,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;

          _this.props.setValue('audienceName', value);
        },
        errorText: "".concat(this.props.audienceName.length, "/50"),
        errorStyle: {
          color: 'rgb(224, 224, 224);'
        },
        floatingLabelStyle: {
          color: 'rgb(139, 139, 139)'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid #616161',
          borderRadius: 2
        }
      }, /*#__PURE__*/React.createElement(Tabs, {
        onChange: function onChange() {
          _this.props.changeField(formName, 'entryType', !fileForm.entryType);
        },
        inkBarStyle: {
          backgroundColor: theme.colors.primaryColor
        },
        tabItemContainerStyle: {
          backgroundColor: theme.colors.secondaryColor
        }
      }, /*#__PURE__*/React.createElement(Tab, {
        label: "Upload CSV"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 24
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          maxWidth: 500,
          color: '#616161'
        }
      }, "Do you have a list of customer email addresses? Upload them here to target them, and people similar to them, in your Facebook ads."), /*#__PURE__*/React.createElement("input", {
        style: {
          marginTop: 20
        },
        ref: function ref(r) {
          return _this.customAudienceField = r;
        },
        onChange: function onChange(_ref2) {
          var _ref2$target$files = _slicedToArray(_ref2.target.files, 1),
              file = _ref2$target$files[0];

          if (file) {
            _this.props.changeField(formName, 'audienceFile', file);
          }
        },
        type: "file",
        name: "fileToUpload",
        id: "fileToUpload"
      }))), /*#__PURE__*/React.createElement(Tab, {
        label: "Enter Manually"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 24
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#616161'
        }
      }, "You can create a custom audience by entering email addresses manually here."), /*#__PURE__*/React.createElement(TextField, {
        hintText: "Enter a single email address per line.",
        multiLine: true,
        rows: 1,
        rowsMax: 12,
        value: fileForm.emailTextInput,
        style: {
          width: 320
        },
        onChange: function onChange(e, val) {
          _this.props.changeField(formName, 'emailTextInput', val);
        }
      })))))));
    }
  }]);

  return CABFileSection;
}(Component)) || _class);
export { CABFileSection as default };